if (!customElements.get('destination-team-finder')) {
  customElements.define(
    'destination-team-finder',
    class DestinationTeamFinder extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.input = this.querySelector('[data-team-filter]');
        this.clearButton = this.querySelector('[data-team-filter-clear]');
        this.status = this.querySelector('[data-team-filter-status]');
        this.results = this.querySelector('[data-team-filter-results]');
        this.empty = this.querySelector('[data-team-filter-empty]');
        this.directory = this.querySelector('[data-team-directory]');
        this.items = Array.from(this.querySelectorAll('[data-team-item]'));

        if (!this.input || !this.clearButton || !this.status || !this.results || !this.empty || this.items.length === 0)
          return;

        this.dataset.initialized = 'true';
        this.input.disabled = false;
        this.desktopQuery = window.matchMedia('(min-width: 990px)');
        if (this.directory) {
          this.directory.open = this.desktopQuery.matches;
          this.desktopQuery.addEventListener('change', (event) => {
            if (!this.input.value) this.directory.open = event.matches;
          });
        }
        this.input.addEventListener('input', () => this.filter());
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown' && !this.results.hidden) {
            event.preventDefault();
            this.results.querySelector('a')?.focus();
            return;
          }

          if (event.key === 'Escape' && this.input.value) {
            event.preventDefault();
            this.reset();
          }
        });
        this.results.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.reset();
          }
        });
        this.clearButton.addEventListener('click', () => this.reset());
        this.filter();
      }

      normalize(value) {
        return value.trim().toLocaleLowerCase();
      }

      matchesQuery(teamName, query) {
        if (!query) return true;

        const normalizedName = this.normalize(teamName);
        return (
          normalizedName.startsWith(query) ||
          normalizedName.split(/\s+/).some((word) => word.startsWith(query))
        );
      }

      filter() {
        const query = this.normalize(this.input.value);
        const matchingItems = [];

        if (this.directory) this.directory.open = query ? false : this.desktopQuery.matches;

        this.items.forEach((item) => {
          if (this.matchesQuery(item.dataset.teamName || '', query)) matchingItems.push(item);
        });

        this.renderResults(query, matchingItems);
        this.clearButton.hidden = !query;
        this.empty.hidden = !query || matchingItems.length > 0;
        const noun = matchingItems.length === 1 ? this.dataset.resultsSingular : this.dataset.resultsPlural;
        this.status.textContent = query ? `${matchingItems.length} ${noun}` : '';
      }

      renderResults(query, matchingItems) {
        const fragment = document.createDocumentFragment();

        if (query) {
          matchingItems.forEach((item) => {
            const sourceLink = item.querySelector('a');
            if (!sourceLink) return;

            const resultItem = document.createElement('li');
            const resultLink = sourceLink.cloneNode(true);
            resultLink.removeAttribute('id');
            resultLink.classList.add('focus-inset');
            resultItem.append(resultLink);
            fragment.append(resultItem);
          });
        }

        this.results.replaceChildren(fragment);
        this.results.hidden = !query || matchingItems.length === 0;
        this.input.setAttribute('aria-expanded', String(!this.results.hidden));
      }

      reset() {
        this.input.value = '';
        this.filter();
        this.input.focus();
      }
    }
  );
}
